import axios from "axios";
import React, { useEffect, useState } from "react";
// import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { formatDateToInputValue } from "../../../config/helperFunctions";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

function AddReturnForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const [orders, setOrders] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [grandTotal, setGrandTotal] = useState(0);
  const [formData, setFormData] = useState({
    ref_no: "",
    date_time: formatDateToInputValue(new Date()),
    description: "",
    menu: [],
    outlet_id: user?.user.outlet_id,
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeQty = (index, value) => {
    const updatedOrder = { ...selectedOrder };
    updatedOrder.order_details[index].qty = Number(value); // or parseFloat if needed
    setSelectedOrder(updatedOrder);
  };

  const handleSelectMenu = (item, checked) => {
    console.log(item, checked);
    const simplifiedItem = {
      name: item.name,
      unit_price:
        item.menu_price_with_discount - item.menu_taxes.vat.toFixed(2),
      qty: item.qty,
      vat: item.menu_taxes.vat,
    };

    setFormData((prev) => {
      if (checked) {
        // Add if not already in the array
        const exists = prev.menu.some(
          (menuItem) => menuItem.name === simplifiedItem.name
        );
        if (!exists) {
          return { ...prev, menu: [...prev.menu, simplifiedItem] };
        }
      } else {
        // Remove if unchecked
        return {
          ...prev,
          menu: prev.menu.filter(
            (menuItem) => menuItem.name !== simplifiedItem.name
          ),
        };
      }
      return prev;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${apiKey}/api/rms/admin/returns`, formData, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.message || "Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err?.response?.data.message || "Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/fetch_all_order`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        setOrders(res.data);
        setError(false);
      })
      .catch((err) => {
        console.log(err?.response?.data.message || "Error Occured");
        setError(err?.response?.data.message || "Error Occured");
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    const order = orders.find((order) => order.sale_no === formData.ref_no);

    setSelectedOrder(order);
  }, [orders, formData.ref_no]);

  useEffect(() => {
    const grandTotal = formData.menu.reduce((acc, item) => {
      return acc + (item.unit_price + item.vat) * item.qty;
    }, 0);
    setGrandTotal(grandTotal);
  }, [formData.menu]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }
  if (error) {
    return <MessageCard error={error} />;
  }
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Add Item")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full lg:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Reference No")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Reference No")}
                    name="ref_no"
                    value={formData.ref_no}
                    onChange={handleChange}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Date")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="datetime-local"
                    value={formData.date_time}
                    readOnly
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-100 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <table className="w-full text-left rtl:text-right">
              <thead>
                <tr>
                  <th>{languageHelper("SN")}</th>
                  <th>{languageHelper("Name")}</th>
                  <th>{languageHelper("Unit Price")}</th>
                  <th>{languageHelper("Vat")}</th>
                  <th>{languageHelper("Quantity")}</th>
                  <th>{languageHelper("Total")}</th>
                  <th>{languageHelper("Actions")}</th>
                </tr>
              </thead>
              <tbody>
                {selectedOrder?.order_details?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>
                      {item.menu_price_with_discount -
                        item.menu_taxes.vat.toFixed(2)}
                    </td>
                    <td>{item.menu_taxes.vat.toFixed(2)}</td>
                    <td>
                      <input
                        type="text"
                        value={item.qty}
                        onChange={(e) => handleChangeQty(index, e.target.value)}
                        className="bg-white border border-d-bg rounded max-w-32 px-2 py-1"
                      />
                    </td>
                    <td>{item.menu_price_with_discount * item.qty}</td>
                    <td className="flex gap-2">
                      <label className="relative flex items-center px-3 rounded-full cursor-pointer">
                        <input
                          type="checkbox"
                          className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-d-bg checked:bg-d-bg checked:before:bg-d-bg hover:before:opacity-10"
                          id={"all"}
                          checked={formData.menu.some(
                            (m) => m.name === item.name
                          )}
                          onChange={(e) =>
                            handleSelectMenu(item, e.target.checked)
                          }
                        />
                        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-3.5 w-3.5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            stroke="currentColor"
                            strokeWidth="1"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </span>
                      </label>
                    </td>
                  </tr>
                  // console.log(item)
                ))}
              </tbody>
            </table>

            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full pt-3">
              <label htmlFor="" className="w-full lg:w-2/4">
                <span className="text-d-bg-text text-sm mb-2 relative ">
                  {languageHelper("Note")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    rows="3"
                    type="text"
                    placeholder={languageHelper("Enter...")}
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="px-2 py-4 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/4"></label>

              <label htmlFor="" className="w-full lg:w-1/4">
                <span className="text-d-bg-text text-sm mb-2 relative ">
                  {languageHelper("Grand Total")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Grand Total")}
                    value={grandTotal.toFixed(2)}
                    readOnly
                    className="p-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-100 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
                disabled={loading}
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddReturnForm;
